import React, { useState } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import DownloadAndReportContent from '../DownloadAndReportContent';
import { imgUrl } from '@/shared/utils';
import { HairLibPublicModel } from '@/types/hairstyle';

const HairstyleCardItemContent = ({
  isDetail = false,
  item,
  onTryOn
}: {
  isDetail?: boolean;
  item?: HairLibPublicModel;
  onTryOn?: (libId: any) => void;
}) => {
  const { t } = useTranslation('common');
  // const router = useRouter();

  const [currentStyle, setCurrentStyle] = useState<any>({});

  return (
    <>
      <div
        className={styles.content}
        onMouseEnter={() => {
          setCurrentStyle({ border: isDetail ? 'none' : `3px solid #9873FF` });
        }}
        onMouseLeave={() => {
          setCurrentStyle({ border: 'none' });
        }}
      >
        <img
          className={styles.imgContainer}
          src={imgUrl(item?.image_url, 'mid')}
          alt={item?.image_alt}
          loading="lazy"
        />

        <div className={styles.coverContainer} style={{ ...currentStyle }}>
          {!isDetail && (
            <div className={styles.bottomContainer}>
              <Image
                className={styles.icon}
                src={imgUrl(item?.blogger_avatar, 'mid')}
                alt={item?.image_alt}
                width={30}
                height={30}
                loading="lazy"
              />
              <span className={styles.name}>{item?.blogger_name}</span>
            </div>
          )}

          <div className={styles.topRightContainer}>
            <DownloadAndReportContent imgUrlStr={item?.image_url} libId={item?.lib_id} />
          </div>

          <div className={styles.tryOnContainer}>
            <span
              onClick={() => {
                if (onTryOn) {
                  onTryOn(item?.lib_id);
                }
              }}
            >
              {t('Try on')}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default HairstyleCardItemContent;
